interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  stepTitle?: string;
  stepDescription?: string;
  progress: number;
}

export const ProgressBar = ({ stepTitle, stepDescription, progress }: ProgressBarProps) => {
  return (
    <div className="mb-8">
      {/* Progress bar */}
      <div className="w-full bg-muted rounded-full h-2 mb-3">
        <div
          className="bg-primary h-2 rounded-full transition-all duration-500 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>

      {/* Step title */}
      {stepTitle && (
        <h2 key={stepTitle} className="text-xl font-semibold text-foreground mt-4 animate-step-title-enter">
          {stepTitle}
        </h2>
      )}
      {stepDescription && <p className="text-sm text-muted-foreground mt-1">{stepDescription}</p>}
    </div>
  );
};
